/**
 * @fileoverview Screen design size constants
 * @module screen-view/constants/designSize
 *
 * Base design dimensions for screen rendering.
 * Based on iPhone 14 Pro (430×932 points).
 *
 * This is the source of truth for screen dimensions.
 * Other modules should import from here.
 */

/**
 * Screen design dimensions
 * Based on iPhone 14 Pro (430×932 points)
 */
export const SCREEN_DESIGN_SIZE = {
  /** Base design width (iPhone 14 Pro) */
  WIDTH: 430,
  /** Base design height (iPhone 14 Pro) */
  HEIGHT: 932,
  /** Computed aspect ratio (~0.461) */
  get ASPECT_RATIO() {
    return this.WIDTH / this.HEIGHT;
  },
} as const;

export type ScreenDesignSize = typeof SCREEN_DESIGN_SIZE;
